export default __webpack_public_path__ + "static/media/twitter.df7f1579.svg";